import React from "react";

import { Flag, InfiniteScroll } from "@common/infiniteScroll";
import { Resource } from "../resource";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourcesList({
  resources,
  isRequestPending,
  canLoadMore,
  retrieveNextResources,
}: Props) {
  return (
    <InfiniteScroll id="costProfilesResources">
      {() => (
        <div className={styles.scrolledList}>
          <ul className={styles.resourcesList}>
            {resources.map((resource) => (
              <li key={resource.uuid} className={styles.item}>
                <Resource resource={resource} />
              </li>
            ))}
          </ul>
          <Flag
            name="costProfilesResourcesFlag"
            retrieveItems={() => !isRequestPending && retrieveNextResources()}
            isDisabled={isRequestPending || !canLoadMore}
          />
        </div>
      )}
    </InfiniteScroll>
  );
}

export { ResourcesList };
